var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRadioChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#FFF",
    fillRule: "nonzero",
    transform: "translate(0 .5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "#CAD2D8",
    transform: "translate(0 .5)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2895F1",
    fillRule: "nonzero",
    cx: 8.5,
    cy: 9,
    r: 4.5
  }))));
}

export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQRDk0Yld3Z2RtVnljMmx2YmowaU1TNHdJaUJsYm1OdlpHbHVaejBpVlZSR0xUZ2lQejRLUEhOMlp5QjNhV1IwYUQwaU1UbHdlQ0lnYUdWcFoyaDBQU0l5TUhCNElpQjJhV1YzUW05NFBTSXdJREFnTVRrZ01qQWlJSFpsY25OcGIyNDlJakV1TVNJZ2VHMXNibk05SW1oMGRIQTZMeTkzZDNjdWR6TXViM0puTHpJd01EQXZjM1puSWlCNGJXeHVjenA0YkdsdWF6MGlhSFIwY0RvdkwzZDNkeTUzTXk1dmNtY3ZNVGs1T1M5NGJHbHVheUkrQ2lBZ0lDQThkR2wwYkdVK2NtRmthVzh0WTJobFkydGxaRHd2ZEdsMGJHVStDaUFnSUNBOFp5QnBaRDBpVUdGblpTMHhJaUJ6ZEhKdmEyVTlJbTV2Ym1VaUlITjBjbTlyWlMxM2FXUjBhRDBpTVNJZ1ptbHNiRDBpYm05dVpTSWdabWxzYkMxeWRXeGxQU0psZG1WdWIyUmtJajRLSUNBZ0lDQWdJQ0E4WnlCcFpEMGljbUZrYVc4dFkyaGxZMnRsWkNJZ2RISmhibk5tYjNKdFBTSjBjbUZ1YzJ4aGRHVW9NUzR3TURBd01EQXNJREV1TURBd01EQXdLU0krQ2lBZ0lDQWdJQ0FnSUNBZ0lEeG5JR2xrUFNKUGRtRnNMVGM0TFVOdmNIa3RNaUlnZEhKaGJuTm1iM0p0UFNKMGNtRnVjMnhoZEdVb01DNHdNREF3TURBc0lEQXVOVEF3TURBd0tTSStDaUFnSUNBZ0lDQWdJQ0FnSUNBZ0lDQThaeUJwWkQwaWNHRjBhQzB4TFd4cGJtc2lJR1pwYkd3OUlpTkdSa1pHUmtZaUlHWnBiR3d0Y25Wc1pUMGlibTl1ZW1WeWJ5SStDaUFnSUNBZ0lDQWdJQ0FnSUNBZ0lDQWdJQ0FnUEdOcGNtTnNaU0JwWkQwaWNHRjBhQzB4SWlCamVEMGlPQzQxSWlCamVUMGlPQzQxSWlCeVBTSTRMalVpUGp3dlkybHlZMnhsUGdvZ0lDQWdJQ0FnSUNBZ0lDQWdJQ0FnUEM5blBnb2dJQ0FnSUNBZ0lDQWdJQ0FnSUNBZ1BHY2dhV1E5SW5CaGRHZ3RNUzFzYVc1cklpQnpkSEp2YTJVOUlpTkRRVVF5UkRnaVBnb2dJQ0FnSUNBZ0lDQWdJQ0FnSUNBZ0lDQWdJRHhqYVhKamJHVWdhV1E5SW5CaGRHZ3RNU0lnWTNnOUlqZ3VOU0lnWTNrOUlqZ3VOU0lnY2owaU9DNDFJajQ4TDJOcGNtTnNaVDRLSUNBZ0lDQWdJQ0FnSUNBZ0lDQWdJRHd2Wno0S0lDQWdJQ0FnSUNBZ0lDQWdQQzluUGdvZ0lDQWdJQ0FnSUNBZ0lDQThZMmx5WTJ4bElHbGtQU0pQZG1Gc0xUZ3hJaUJtYVd4c1BTSWpNamc1TlVZeElpQm1hV3hzTFhKMWJHVTlJbTV2Ym5wbGNtOGlJR040UFNJNExqVWlJR041UFNJNUlpQnlQU0kwTGpVaVBqd3ZZMmx5WTJ4bFBnb2dJQ0FnSUNBZ0lEd3ZaejRLSUNBZ0lEd3ZaejRLUEM5emRtYysi";
export { SvgRadioChecked as ReactComponent };